import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogComponent } from 'src/app/custom-components/dialog/dialog.component';
import { DialogConfig } from 'src/app/custom-components/dialog/interfaces/dialog-config.interface';
import { DialogTipo } from 'src/app/custom-components/dialog/utils/dialog-type.enum';
import { AplicacionTipoService } from 'src/app/_module/procesadora/aplicacion-datos/aplicacion-tipo/aplicacion-tipo.service';
import { NotificacionesService } from 'src/app/_app_services/notificaciones.service';
import {Formularios} from 'src/app/_helpers/clases/formularios';
import { PageHeaderDataService } from 'src/app/shared/services/page-header-data.service';
import { AplicacionTipo } from 'src/app/_models/aplicacion-tipo';
import {PageHeaderData} from 'src/app/shared/components/forms-header/page-header-data';


/**
  * Formulario ABM para los tipos de aplicaciones.
  * @author Alejandro Planas, David Ozorio
  */
@Component({
  selector: 'app-aplicacion-tipo-form',
  templateUrl: './aplicacion-tipo-form.component.html',
  styleUrls: ['./aplicacion-tipo-form.component.scss']
})
export class AplicacionTipoFormComponent extends Formularios<AplicacionTipo> implements OnInit {

  constructor(
    public dialog: MatDialog,
    public router: Router,
    private fb: FormBuilder,
    public service: AplicacionTipoService,
    public notificacionService: NotificacionesService,
    private headerDataService: PageHeaderDataService
  ) {
    super(router, dialog, 'procesadora/aplicacion_tipo', service, notificacionService);
  
  } 

    ngOnInit(): void {
      super.ngOnInit();
      super.formularioAbs = this.construirFormGroup();
      if (super.editar) {
        super.formularioAbs.setValue(this.service.getItem());
      } else {
        this.service.restartItem();
      }
      this.headerDataService.setHeaderData(new PageHeaderData('Tipo de aplicaciones', this.rutaPadre, true));
    }
  
  
    construirFormGroup(): FormGroup {
      return this.fb.group({
        id: [null],
        nombre: [{value: '', disabled: super.dis}, Validators.required],
                
      });
    }
  
    getErrorMessage(cName: string): string {
      if (this.formularioAbs.controls[cName].hasError('required')) {
        return 'Campo requerido';
      }
    }
  }